<template>
  <snap-main-navigation
    id="main-navigation"
    :navigationOptionsInput.prop="getNavigationOptions"
    corner="true"
    theme="store"
    @navigationupdate="onNavigationUpdate($event)"
  ></snap-main-navigation>
</template>
<script lang="ts" setup>
//Imports
import { computed } from "vue";
import { useRouter } from "vue-router";
import { useMainStore } from "@/store/MainStore";
import FEATURE_FLAGS from "@/split-adapter/feature-flags";
import useFeatureFlagsStore from "@/store/feature-flags";

interface IMainNavigationOption {
  id: string;
  text: string;
  active: boolean;
  icon: string;
  path: string;
  forceNavigation: boolean;
}

const PAYABLE_ROUTE = {
  id: "payables",
  text: "Payables",
  active: false,
  icon: "cash-solid",
  path: "/payables",
  forceNavigation: false,
};

const mainStore = useMainStore();
const featureFlagStore = useFeatureFlagsStore();
const isFeatureOn = computed(() => featureFlagStore.isOn(FEATURE_FLAGS.INTERNAL_ADMIN));

const router = useRouter();

const onNavigationUpdate = (event: CustomEvent) => {
  router.push(event.detail.path);
  mainStore.setCurrentSidebarOption(event.detail.id);
};

const NAVIGATION_OPTIONS: IMainNavigationOption[] = [
  {
    id: "stores",
    text: "Stores",
    active: mainStore.getCurrentSidebarOption === "stores",
    icon: "template-solid",
    path: "/",
    forceNavigation: false,
  },
  {
    id: "welcome",
    text: "Welcome",
    active: false,
    icon: "template-solid",
    path: "/welcome",
    forceNavigation: false,
  },
];
const getNavigationOptions = computed(() => {
  const currentSidebarOption = mainStore.getCurrentSidebarOption;
  const options = [...NAVIGATION_OPTIONS];
  isFeatureOn.value && options.push(PAYABLE_ROUTE);
  options.forEach((option) => {
    option.active = option.id === currentSidebarOption;
  });
  if (!mainStore.getAllStoreIds.length) {
    return options.filter((option) => option.id === "welcome");
  } else {
    return options.filter((option) => option.id !== "welcome");
  }
});
</script>
<style></style>
